module.exports = __webpack_public_path__ + "img/Ladylike-Glamour.2ef9702d.jpg";